import { FC, useEffect } from 'react';
import ControllersTab from '@/components/StateMachine/ControllersTab';
import ControlKPIsTab from '@/components/StateMachine/ControlKPIsTab';
import './index.scss';
import { Tab } from '@hydrodigital/design-system'
import { useSearchParams } from 'react-router-dom';

/**
 * @author
 * @function @StateMachineView
 **/

const StateMachineView: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleTabChange = (tabId: string) => {
    setSearchParams({ tab: tabId });
  };

  // Establecer tab por defecto si no existe
  useEffect(() => {
    if (!searchParams.get('tab')) {
      setSearchParams({ tab: 'controllers' });
    }
  }, [searchParams, setSearchParams]);

  return (
    <div>
      <div className="text-title-page">Smart Controls</div>
      <Tab
        onTabChange={handleTabChange}
        orientation="horizontal"
        className='mt-3 ml-4'
        showContent
        tabs={[
          {
            content: <ControllersTab key="controllers" />,
            id: 'controllers',
            label: 'CONTROLLERS'
          },
          {
            content: <ControlKPIsTab key="control-kpis" />,
            id: 'control-kpis',
            label: 'RECOMMENDATION LOGIC'
          }
        ]}
      />
    </div>
  );
};

export default StateMachineView;
